var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoDinersClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 35C60 37.75 57.75 40 55 40H5C2.25 40 0 37.75 0 35V5C0 2.25 2.25 0 5 0H55C57.75 0 60 2.25 60 5V35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6517 20.2889C12.6517 11.9923 19.3774 5.2666 27.6737 5.2666C35.9703 5.2666 42.6959 11.9923 42.6959 20.2889C42.6959 28.5855 35.9703 35.3115 27.6737 35.3115C19.3774 35.3115 12.6517 28.5855 12.6517 20.2889",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7585 19.9932C36.7525 16.1462 34.3479 12.8653 30.9595 11.566V28.4197C34.3479 27.1187 36.7525 23.8408 36.7585 19.9932ZM24.4957 28.4165V11.5677C21.1104 12.8711 18.7095 16.1473 18.7004 19.9933C18.7095 23.8382 21.1104 27.1141 24.4957 28.4165ZM27.7294 5.74781C19.8622 5.75083 13.4884 12.126 13.487 19.9932C13.4884 27.8594 19.8622 34.2335 27.7294 34.2348C35.5966 34.2335 41.9717 27.8594 41.9737 19.9932C41.9717 12.126 35.5966 5.75083 27.7294 5.74781ZM27.6944 35.5792C19.0856 35.6202 12 28.6457 12 20.1557C12 10.877 19.0856 4.45926 27.6944 4.46094H31.7288C40.2359 4.45926 48 10.874 48 20.1557C48 28.6427 40.2359 35.5792 31.7288 35.5792H27.6944Z",
    fill: "#0069AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDinersClub);
export default __webpack_public_path__ + "static/media/ico_dinersClub.66210c63c4aa8cae8c5a3e8f7354013f.svg";
export { ForwardRef as ReactComponent };